import { formatDate, isToday } from '../../lib/date';

/**
 *
 * @param {Signature[]} signatures
 * @returns {Array<Signature[]>}
 */
export function getSignaturesGroupedArray(signatures) {
    const groupedSignaturesMap = signatures
        .slice()
        .sort((curr, prev) => curr.dateCreated.localeCompare(prev.dateCreated))
        .reduce((groups, item) => {
            const signatureEdrpou =
                item.keyOwnerEdrpou || item.stampOwnerEdrpou;
            if (signatureEdrpou) {
                groups[signatureEdrpou] = groups[signatureEdrpou] || [];
                groups[signatureEdrpou].push(item);
            }
            return groups;
        }, {});

    // convert object into sorted array
    const groupedSignatures = Object.values(groupedSignaturesMap);

    return groupedSignatures.sort((curr, prev) => {
        // sort companies signatures group
        return curr[0].dateCreated.localeCompare(prev[0].dateCreated);
    });
}

export function getLinkedRecipient(doc) {
    if (doc.edrpouRecipient) {
        return {
            edrpouRecipient: doc.edrpouRecipient,
            emailRecipient: doc.emailRecipient,
        };
    }
    const parent = doc.parent && doc.parent.document;
    if (parent && parent.displayCompanyEdrpou) {
        return {
            edrpouRecipient: parent.displayCompanyEdrpou,
            emailRecipient: parent.displayCompanyEmail,
        };
    }
    for (const child of doc.children || []) {
        const childDoc = child.document;
        if (childDoc.displayCompanyEdrpou) {
            return {
                edrpouRecipient: childDoc.displayCompanyEdrpou,
                emailRecipient: childDoc.displayCompanyEmail,
            };
        }
    }
    return { edrpouRecipient: '', emailRecipient: '' };
}

export function shouldRenderReviewOnDoc(currentUser) {
    const company = currentUser.currentCompany;
    const companyConfig = company.config;
    return Boolean(companyConfig && companyConfig.render_review_in_interface);
}

export const formatDateTime = (date) => {
    if (isToday(date)) {
        return formatDate(date, 'HH:mm');
    }
    return formatDate(date, 'HH:mm DD.MM.YY');
};

/**
 * @param {DocumentFlowItem} flow
 * @param {IUser} user
 * @returns {boolean}
 */
export const isOwnFlowItem = (flow, user) =>
    flow.edrpou === user.currentCompany.edrpou &&
    flow.receivers.emails.includes(user.email);
